export enum UserProfilePermissionLevel {
  'ADMIN' = 'admin',
  'STUDENT_MANAGER' = 'student_manager',
  'STUDENT_VIEWER' = 'student_viewer'
}
